import React from "react";
import {
  Card,
  Box,
  Typography,
  Grid,
  Divider,
  Chip,
} from "@mui/material";
import { AccessTime, Login, Logout, Coffee } from "@mui/icons-material";

const AttendanceCard = ({
  title = "Daily Attendance",
  checkIn,
  checkOut,
  breakIn,
  breakOut,
  status,
}) => {
  // Dynamic color for status
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "onTime":
        return "success";
      case "absent":
        return "error";
      case "late":
        return "warning";
      default:
        return "default";
    }
  };

  return (
    <Card
      sx={{
        border: "1.5px solid #2E7D32",
        borderRadius: "16px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        p: 3,
        bgcolor: "#fff",
        height: "100%",
      }}
    >
      {/* Header */}
      <Box textAlign="center" mb={2}>
        <Typography variant="h6" fontWeight={600} color="text.primary">
          {title}
        </Typography>
        <Chip
          label={status }
          color={getStatusColor(status)}
          size="small"
          sx={{ mt: 1 }}
        />
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* Times Grid */}
      <Grid container spacing={2}>
        <Grid item xs={6} textAlign="center">
          <Login color="success" />
          <Typography variant="body2" color="text.secondary">
            Check In
          </Typography>
          <Typography variant="h6" fontWeight={600} color="text.primary">
            {checkIn || "--"}
          </Typography>
        </Grid>
        <Grid item xs={6} textAlign="center">
          <Logout color="error" />
          <Typography variant="body2" color="text.secondary">
            Check Out
          </Typography>
          <Typography variant="h6" fontWeight={600} color="text.primary">
            {checkOut || "--"}
          </Typography>
        </Grid>
        <Grid item xs={6} textAlign="center">
          <Coffee sx={{ color: "#ff9800" }} />
          <Typography variant="body2" color="text.secondary">
            Break In
          </Typography>
          <Typography variant="h6" fontWeight={600} color="text.primary">
            {breakIn || "--"}
          </Typography>
        </Grid>
        <Grid item xs={6} textAlign="center">
          <Coffee sx={{ color: "#6d4c41" }} />
          <Typography variant="body2" color="text.secondary">
            Break Out
          </Typography>
          <Typography variant="h6" fontWeight={600} color="text.primary">
            {breakOut || "--"}
          </Typography>
        </Grid>
      </Grid>

    </Card>
  );
};

export default AttendanceCard;
